module.exports = __webpack_public_path__ + "img/crow.be5030ca.webp";